import styled, { createGlobalStyle, DefaultTheme } from 'styled-components'

interface Props {
  isSwap: boolean
  isFaucet: boolean
  theme: DefaultTheme
}

export const GlobalStyles = createGlobalStyle<Props>`
  // Using rem for text over pixel
  // https://chiamakaikeanyi.dev/sizing-in-css-px-vs-em-vs-rem/
  // Deep explanation : https://www.youtube.com/watch?v=dHbYcAncAgQ
  * {
    box-sizing: border-box;
  }

  .web3modal-modal-card{
    background-color: ${({ theme }) => theme.modalBackground};
    color: ${({ theme }) => theme.text};

    display: flex;
    flex-direction: column;
    width: 400px;
    span{
      width: 400px;
    }
  }
  
  .web3modal-provider-description{
    display: none;
  }
  /*.web3modal-provider-wrapper:nth-of-type(2){
    display: none;
  }*/

  .web3modal-modal-card {
  	border-radius: 35px;
  	padding: 1rem;
    padding-bottom: 3.5rem;
  }

  .web3modal-provider-wrapper{
    border: initial;
    .web3modal-provider-container{
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      border-radius: 20px;
      padding: 6px 24px ;
      background-color: ${({ theme }) => theme.modalButtonBackgroundColor};
      border: ${({ theme }) => 'solid thin ' + theme.modalBoxBackground};
      opacity: 1;

      .web3modal-provider-name{
        width: initial;
        font-size: initial;
        font-weight: initial;
        margin: initial;
        color: ${({ theme }) => theme.modalButtonColor};
      }
      
      img{
        width: 70%;
      }

      :hover {
      	border: ${({ theme }) => 'solid thin ' + theme.modalBoxBorder} ;
      	background-color: ${({ theme }) => theme.modalButtonBackgroundColorHover};
      }

    }
  }
  
  
  div.top-connect-modal{
    div.connect-modal-box{
      text-align: justify;
      border-radius: 15px;
      margin: 10px;
      padding: 6px 24px ;
      border: ${({ theme }) => 'solid thin ' + theme.modalBoxBackground} ;
    }

  }

  div.bottom-connect-modal{
    margin: 10px;
    padding: 0;
    text-align: justify;
    
  }
  
  
  
  
  html {
    font-size: 62.5%; /* Very standard math trick : 1rem = 10px */
  }

  body {
    margin: 0;
    font-size: 1.6rem; /* 16px, standard navigator setting */
  }
  
  body {
    background: ${({ theme, isSwap, isFaucet }) =>
      isSwap ? theme.bodySwap : isFaucet ? theme.bodyFaucet : theme.body};
    color: ${({ theme }) => theme.text};
    transition: all 0.50s linear;
  }
  
  a.link{
    color:${({ theme }) => theme.link};
    text-decoration: none;
    &:hover{
      text-decoration: underline;
    }
  }

  a.back-link{
    color:${({ theme }) => theme.text};
    text-decoration: none;
    &:hover{
      text-decoration: underline;
    }
  }
  // for debugging
  .bgy{
    background-color: yellow;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .flex-column,.flex-col {
    display: flex;
    flex-direction: column;
  }

  .justify-around {
    display: flex;
    justify-content: space-around;
  }

  .justify-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .justify-center {
    display: flex;
    justify-content: center;
  }

  .align-center {
    display: flex;
    align-items: center;
  }

  .text-center{
    text-align: center;
    justify-content: center;
  }

  .text-right{
    text-align: right; // block layout
    justify-content: end; // in case of flex layout
  }

  .text-left{
    text-align: left; // block layout
    justify-content: start; // in case of flex layout
  }

  .relative{
    position: relative;
  }

  .pr10{
    padding-right:10px;
  }

  .mt40{
    margin-top: 40px;
  }
  .mt20{
    margin-top: 20px;
  }
  .mt10{
    margin-top: 10px;
  }
  .mt5{
    margin-top: 5px;
  }
  .mb5{
    margin-bottom: 5px;
  }

  .mr20{
    margin-right: 20px;
  }
  .mr10{
    margin-right: 10px;
  }
  .ml20{
    margin-left: 20px;
  }
  .ml10{
    margin-left: 10px;
  }
  .ml5{
    margin-left: 5px;
  }
  .mr5{
    margin-right: 5px;
  }

  .p5{
    padding: 5px;
  }
  .p10{
    padding: 10px;
  }
  .p20{
    padding: 20px;
  }
  .plr10{
    padding:0 10px;
  }
  .plr20{
    padding:0 20px;
  }
  
  
  .pr20{
    padding-right:20px;
  }
  .pt15{
      padding-top:15px;
    }
  .pt20{
    padding-top:20px;
  }
  .pt10{
    padding-top:10px;
  }
  .pt5{
    padding-top:5px;
  }

  .fs12, .small-text{
    font-size: 1.2rem;
  }
  .fs16, .normal-text{
    font-size: 1.5rem;
  }
  .fs18, .normal-text{
    font-size: 1.75rem;
  }
  .fs20, .big-text{
    font-size: 2rem;
  }
  .fs32{
    font-size: 3.2rem;
  }
  
  //TODO: remove this
  .w300{
    width: 300px;
  }
  
  .w100{
    width: 100%;
  }
  
  
  
  .headerRightContent{
    width: 600px;
    @media (max-width: 1200px) {
      width: 50px
    }
  }

  .headerLeftContent{
    width: 600px;
    @media (max-width: 1200px) {
      width: 100%
    }
  }

  .shadow-text{
    color:${({ theme }) => theme.shadowText};
  }

  .numeric{
  	font-family: Montserrat-Medium, Montserrat;
  }

  .light{
  	font-family: Montserrat-Light;
  }

  /**
  * Sticky footer
  */
  html, body {
    height: 100%;
  }
  body {
    display: flex;
    flex-direction: column;
  }

  main.content {
    flex: 1 0 auto;
  }
  footer.footer {
    flex-shrink: 0;
  }


  body.withPopup{
    margin:0;
    height: 100%;
    overflow: hidden;
  }

`
